import _ from 'lodash'

export default function(jwt, roles) {
    return function(to, from, next){
        var valid = _.find(roles, function(r) { return r == jwt.getRole(); }) !== undefined;
        if(valid){
            next()
        }else{
            if(from === undefined || from.name === null || from.name === undefined){
                next('login')
            }else{
                next({name: from.name});
            }
        }
    }
}


// WEBPACK FOOTER //
// ./WebApp/utils/authorize.js